import { SupportedProductType } from '@/types/api';

/**
 * Product types the add-ons step (ProductSelection) can offer on top of the chosen
 * sick-leave quote. If none of these appear in the quote's `relevant_product_types`, the
 * add-ons step has nothing to choose and is a pass-through to review. Kept in one place so
 * the page (which sections to render) and the flow guidance (what the next step is) agree.
 */
export const ADD_ON_PRODUCT_TYPES: readonly SupportedProductType[] = [
	SupportedProductType.OCCUPATIONAL_HEALTH_SERVICE,
	SupportedProductType.SICK_LEAVE_LONG_TERM_WGA_GAP_EXTENDED,
	SupportedProductType.SICK_LEAVE_LONG_TERM_WIA_EXCESS
];

/**
 * True when the client has at least one add-on product to choose on the add-ons step.
 * Accepts the raw `relevant_product_types` strings from the API (which aren't narrowed to
 * the enum), comparing them against the add-on types' string values.
 */
export function hasAddOnProducts(
	relevantProductTypes: readonly string[] | null | undefined
): boolean {
	if (!relevantProductTypes) return false;
	return ADD_ON_PRODUCT_TYPES.some((type) => relevantProductTypes.includes(type));
}
